<kendo-card class="counter-card">
  <kendo-card-header class="k-hstack">
    <div>

      <h1 kendoCardTitle><kendo-icon name="clip"></kendo-icon> C: {{ refNumber }}</h1>
      <p kendoCardSubtitle> Device:        {{ used }} </p>

    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body>
    <p style="color:#231ba4;">
    <p>
      Counts:   {{ cntStatus.counts  }} <br/>
      Counts since refresh: <small> ( {{ cntStatus.active }} )</small> <br/>
    </p>
  </kendo-card-body>

  <kendo-card-footer>
  </kendo-card-footer>
</kendo-card>


